<template>
  <div class="wrap" v-if="showList">
    <all-very-well v-if="noRegister" :source="'index'"></all-very-well>
    <div class="indexWrap" v-if="showIndex">
      <my-head
        :showHome="showHome"
        :showList="showList"
        :indexShow="false"
        :pageType="1"
      ></my-head>
      <div class="logo">
        <img src="../static/images/logo_new.png" alt="" />
      </div>
      <div class="shadow"></div>
      <!-- 搜索部分 -->
      <div class="paddingBox">
        <div class="search_box">
          <div class="landBox">
            <!-- 地标 -->
            <div class="searchState clearfix" @click="chooseCity">
              <span class="fl iconfont">&#xe827;</span>
              <span class="fl weight state">&nbsp;&nbsp;{{ cityName }}</span>
              <span class="fr iconfont icon" @click.stop="getMyLocation">
                &#xe808; {{ position }}</span
              >
            </div>
            <div class="searchState clearfix" @click="checkDate">
              <span class="fl iconfont">&#xe828;</span>
              <span class="state">
                <i class="weight">&nbsp;&nbsp;{{ checkIn }}</i>
                <em>{{ weekSt }}</em>
              </span>
              <span class="state">
                <i class="weight"> - {{ checkOut }}</i>
                <em>{{ weekEt }}</em>
              </span>
              <span class="fr night">共{{ totalDay }}晚</span>
            </div>
          </div>
          <div class="landDetail weight clearfix" @click="choosePlace">
            <span class="iconfont">&#xe826;</span>
            <span class="landmark" v-if="!landmark">
              位置/地名/房源
            </span>
            <span class="landmark location" v-else>
              {{ landmark }}
            </span>
            <span
              class="iconfont fr close"
              @click.stop="clearLand"
              v-if="landmark"
              >&#xe73d;</span
            >
          </div>
          <!-- 搜索按钮 -->
          <div class="searchBtn" @click="searchList">查找房源</div>
        </div>
      </div>
      <!-- 标签部分 -->
      <div
        class="searchLable"
        v-if="iconList.length > 0 && iconList.length == 4"
      >
        <div
          class="lable"
          v-for="(icon, index) in iconList"
          @click="toSearch(icon)"
          :key="index"
        >
          <img :src="icon.imgurl" alt="" />
          <span>{{ icon.label }}</span>
        </div>
      </div>
      <!-- 大家都在玩 -->
      <div class="playBox" v-if="playList.list && playList.list.length > 0">
        <div class="recommendName weight">{{ playList.title }}</div>
        <div class="playSwiper">
          <div
            :class="{
              'play-slide': true,
              'one-slilde': playList.list.length == 1
            }"
            :key="idex"
            @click="goUrl(item.linkUrl)"
            v-for="(item, idex) in playList.list"
          >
            <img :src="item.imgurl" alt="" />
          </div>
        </div>
      </div>
      <!--热门民宿 -->
      <div class="hotBox" v-if="hotLuList.length > 0">
        <div class="recommendName weight">{{ cityName }}热门民宿</div>
        <div class="roomBox">
          <div
            class="hotRoomBox"
            @click="roomDetail(house.luId)"
            :key="index"
            v-for="(house, index) in hotLuList"
          >
            <div class="imgBox">
              <img :src="house.luMainImageUrl" />
            </div>
            <div class="luInfo">
              <div class="luBox">
                <p class="luName">
                  {{ house.luTitle }}
                </p>
                <p class="type">
                  {{ house.houseTypeInfo }}·{{ house.guestnum }}
                </p>
              </div>
              <div class="price">
                <span class="nowPrice weight" v-if="house.couponPrice">
                  ￥{{ house.couponPrice }}
                </span>
                <span class="gray">起/晚</span>
                <!-- <span class="gray">￥325</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 更多 -->
      <div class="paddingBox" v-if="hotLuList.length > 0">
        <div class="more weight" @click="getMore">
          更多{{ cityName }}优质房源
        </div>
      </div>
      <div class="bottom-record">
        <span
          v-for="(item, index) in bottomData"
          :key="index"
          @click="bottomClick(item)"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Indicator, Swipe, SwipeItem, Lazyload } from "mint-ui";
import {
  locationCity,
  getIndexBanner,
  getVipInfo,
  indexSearch,
  getResultList,
  getThirdInfo,
  hbgjLogin
} from "../service/getData";
import Vue from "vue";
import { joinCb, rendNewMsg, dealWithTheImData } from "@/tools/im.js";
import getUa from "@/utils/getUa";
export default {
  data() {
    return {
      bottomData: [
        {
          label: "关于小猪",
          link: "https://m.xiaozhu.com/#/aboutUs/AboutXz"
        },
        {
          label: "客服电话：400-010-7890",
          link: ""
        },
        {
          label: "营业执照",
          link: "https://m.xiaozhu.com/app/certificate/yingye.html"
        },
        {
          label: "许可证号：京ICP证140510号",
          link: ""
        },
        {
          label: "京ICP证12035936号-1",
          link: "http://beian.miit.gov.cn"
        },
        {
          label: "京公安网安备11010802020380号",
          link:
            "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020380"
        }
      ],
      playList: {},
      watchList: {},
      cityName: this.getStore("cityName")
        ? this.getStore("cityName").toString()
        : "北京",
      landmark:
        this.$route.query && this.$route.query.landmark
          ? this.$route.query.landmark
          : "",
      checkIn: this.getStore("setData")
        ? JSON.parse(this.getStore("setData"))
            .checkInDay.slice(5)
            .split("-")
            .join(".")
        : "",
      checkOut: this.getStore("setData")
        ? JSON.parse(this.getStore("setData"))
            .checkOutDay.slice(5)
            .split("-")
            .join(".")
        : "",
      totalDay:
        this.getStore("setData") && !this.checkIn
          ? JSON.parse(this.getStore("setData")).keepDays
          : "",
      userInfo: this.getStore("userInfo")
        ? JSON.parse(this.getStore("userInfo"))
        : "",
      showIndex: false,
      noRegister: false,
      imkey: {
        sessionId: "im_sessionId"
      },
      today: "",
      tommorrow: "",
      timer: [],
      weekSt: "今天",
      weekEt: "明天",
      hotLuList: [],
      position: "我的位置",
      iconList: [],
      showList: false,
      showHome: true,
      replaceURl: 'https://minsu.xiaozhu.com'
    };
  },
  metaInfo: {
    title: "小猪—酒店之外，就住小猪；短租民宿公寓预订佳选",
    meta: [
      {
        name: "keywords",
        content: "日租房,短租房,小猪短租,短租公寓,酒店式公寓,青年旅舍,小猪"
      },
      {
        name: "description",
        content:
          "小猪是国内知名的短租民宿预订平台，更是一个具有人情味的社交住宿社区。至19年5月小猪全球房源已经突破80万，覆盖国内700座城市和海外252个目的地，房源包括特色民宿、精品客栈、城市公寓、轰趴别墅、海边小屋、花园洋房、森林木屋等，让您充分感受住宿之美、人情之暖、分享之乐。"
      }
    ]
  },
  components: {
    allVeryWell: resolve => {
      require(["@/components/actPop/allVeryWell.vue"], resolve);
    }
  },
  created() {
    // window.location.replace(`https://${isProduction ? 'minsu' : 'test-minsu'}.xiaozhu.com`);
    if (window.location.href.split("#")[0].indexOf("shareId") > 0) {
      this.showIndex = false;
    } else {
      this.showIndex = true;
    }
    const urlParams = new URLSearchParams(window.location.search);
    let source = urlParams.get('source');
    let code = urlParams.get('code');
    if (source === 'aviationButler') {
      this.setCookie("source", source);
      this.flyButlerSilentLogin(source, code) //航班管家app内静默登陆 
    } else {
      this.showList = true;
      window.location.replace(this.replaceURl)
    }
  },
  mounted() {
    this.initPage();
    this.getHotCity();
    this.initCity();
    if (this.getStore("userInfo")) {
      Vue.prototype.userInfo = this.userInfo;
      this.getVipInfoObj();
      this.startXiaoZhuIm();
    }
    this.initData();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const that = vm;
      let shareId = null;
      if (window.location.href.split("#")[0].indexOf("inviterId") > 0) {
        const shareUrl = window.location.href.split("#")[0].split("?")[0];
        const shareParams = window.location.href.split("#")[0].split("?")[1];
        window.location.href = `${shareUrl}shareinvite.html?${shareParams}`;
      }
      // 删除缓存
      if (window.location.href.split("#")[0].indexOf("shareId") > 0) {
        that.showIndex = false;
        let links = window.location.href.split("#")[0].split("?");
        links = links[0] + "#/?" + links[1];
        window.location.href = links;
      } else {
        that.showIndex = true;
        shareId = that.getUrlParms(window.location.href).shareId;
      }
      if (shareId) {
        that.$router.push({
          name: "detail",
          query: {
            luId: shareId
          }
        });
      } else if (shareId === "") {
        that.$router.push({
          name: "shareDiscount"
        });
      }
    });
  },
  methods: {
    async flyButlerSilentLogin(source, code) {
      try {
        const thirdInfoRes = await this.$get(getThirdInfo, { code, channel: 'hbgj' });
        const thirdInfo = thirdInfoRes.content;
        const loginData = await this.$get(hbgjLogin, thirdInfo);
        this.setStore("userInfo", loginData.content);
        this.setStore("xzuser", loginData.content);
        this.setStore("jsversion", "d7m4g9s8");
        this.setStore("d7m4g9s8xzlogin", true);
        this.setStore("d7m4g9s8xzuser", loginData.content);
        this.setCookie("userInfo", JSON.stringify(loginData.content));
        this.$store.commit("login", loginData.content);
        window.location.replace(this.replaceURl)
      } catch (error) {
        console.error('interface error:', error);
        window.location.replace(this.replaceURl)
      }
      this.showList = true;
    },
    showPop() {
      const that = this;
      let year, month, day;
      const startTime = "2019-03-19";
      const endTime = "2019-05-19";
      const today = new Date();
      function format(date) {
        year = date.getFullYear();
        month = date.getMonth() + 1;
        day = today.getDate();
        if (month <= 9) {
          month = "0" + month;
        }
        if (day <= 9) {
          day = "0" + day;
        }
        const data2 = year + "-" + month + "-" + day;
        return data2;
      }
      const formatToday = format(today);
      if (startTime < formatToday && formatToday < endTime) {
        that.noRegister = true;
      }
    },
    getApi(url, datas, complete) {
      const req = $.ajax({
        type: "GET",
        url: url,
        dataType: "jsonp",
        async: true,
        data: datas
      });
      if (complete) req.complete(complete);
    },
    join() {
      const that = this;
      const params = getUa.userAgent.isLark
        ? {
            sessionId: that.getSessionId(),
            token: that.userInfo.imToken,
            fromUserId: that.userInfo.userId,
            fromUserClientType: "h5",
            jsonCallback: "joinCb",
            bundleType: "biz" // 兼容飞书
          }
        : {
            sessionId: that.getSessionId(),
            token: that.userInfo.imToken,
            fromUserId: that.userInfo.userId,
            fromUserClientType: "h5",
            jsonCallback: "joinCb"
          };
          params.client = "html5"
      that.getApi(imroot + "/join", params, that.joinComplete);
    },
    joinComplete(XMLHttpRequest) {
      const that = this;
      if (XMLHttpRequest.status != 200) {
        setTimeout(function() {
          that.join();
        }, 6000);
      } else {
        setTimeout(function() {
          that.refresh();
        }, 2000);
      }
    },
    refreshComplete(XMLHttpRequest) {
      const that = this;
      if (XMLHttpRequest.status != 200) {
        that.join();
      } else {
        setTimeout(function() {
          that.refresh();
        }, 2000);
      }
    },
    getSessionId() {
      const that = this;
      const key = that.imkey.sessionId;
      var sessionId = that.getLocalStorage(key);
      if (!sessionId) {
        var sessionId = new Date().getTime();
        that.setLocalStorage(key, sessionId);
      }
      return sessionId;
    },
    refresh() {
      const that = this;
      const params = getUa.userAgent.isLark
        ? {
            sessionId: that.getSessionId,
            token: that.userInfo.imToken,
            fromUserId: that.userInfo.userId,
            fromUserClientType: "h5",
            jsonCallback: "refreshCb",
            imVersion: 3, // 3.0版本 兼容im机器人推送
            bundleType: "biz" // 兼容飞书
          }
        : {
            sessionId: that.getSessionId,
            token: that.userInfo.imToken,
            fromUserId: that.userInfo.userId,
            fromUserClientType: "h5",
            jsonCallback: "refreshCb",
            imVersion: 3 // 3.0版本 兼容im机器人推送
          };
           params.client = "html5"
      window.refreshCb = function(data) {
        that.$store.commit("setRequest", false);
        if (data) {
          if (data.length === undefined) {
            dealWithTheImData(data, true, true);
            rendNewMsg(data);
            // }
          } else {
            for (let i = 0, length = data.length; i < length; i++) {
              dealWithTheImData(data[i], true, true);
              rendNewMsg(data[i]);
            }
          }
        }
      };
      that.getRefresh(imroot + "/refresh", params, that.refreshComplete);
    },
    getRefresh(url, datas, complete) {
      const that = this;
      if (that.$store.state.isRequest) {
        return false;
      }
      const req = $.ajax({
        type: "GET",
        url: url,
        dataType: "jsonp",
        async: true,
        timeout: 60000,
        data: datas,
        beforeSend: function() {
          that.$store.commit("setRequest", true);
        },
        success: function(data) {
          that.$store.commit("setRequest", false);
        }
      });
      if (complete) req.complete(complete);
    },
    getToken() {
      return 0;
    },
    startXiaoZhuIm() {
      const that = this;
      that.getToken();
      var timer = setInterval(function() {
        if (that.userInfo.imToken) {
          that.join();
          clearInterval(timer);
        }
      }, 1000);
      that.$once("hook:beforeDestroy", () => {
        window.clearInterval(timer);
      });
      that.timer.push(timer);
    },
    initPage() {
      const that = this;
      // 页面初始化接口
      const params = {
        cityId: that.getStore("abroad") ? JSON.parse(that.getStore("abroad")).cityId  : "12",
        typeChannel: "MWebSite"
      };
      Indicator.open(); 
      that.$get(indexSearch, params).then(res => {
        try {
          Indicator.close();
          if (res.status != 200) return Toast(res.errorMsg);
          if (res.content) {
            for (
              var i = 0, val;
              (val = res.content.operationalPositions[i++]);

            ) {
              if (val.position == "wechat_mini_header_activity") {
                // 大家都在玩儿
                that.playList = val;
              } else if (val.position == "whchat_mini_classification_icon") {
                // 分类图标
                that.iconList = val.list;
              } else if (val.position == "wechat_mini_middle_activity") {
                // 大家都在看
                that.watchList = val;
              }
            }
          }
        } catch (error) {
          
        }
      }).catch(() => {
      });
    },
    getMyLocation() {
      const that = this;
      that.position = "定位中...";
      that
        .getPosition()
        .then(result => {
          // 返回结果示例：
          const queryData = {
            longtitude: String(result.longitude).match(/\d+\.\d{0,6}/)[0],
            latitude: String(result.latitude).match(/\d+\.\d{0,6}/)[0],
            channelType: "00"
          };
          that
            .$get(locationCity, {
              lat: queryData.latitude,
              lng: queryData.longtitude
            })
            .then(response => {
              that.position = "我的位置";
              if (response.status == 200) {
                that.cityName = response.content.cityShortName;
                that.setStore("cityName", response.content.cityShortName);
                if (response.content.isAbroad) {
                  that.setStore("hasAbordCity", 1);
                }
                that.landmark = response.content.locName;
                const localInfo = response.content;
                localInfo.longitude = queryData.longtitude;
                localInfo.latitude = queryData.latitude;
                that.setStore("abroad", JSON.stringify(localInfo));
                that.getHotCity();
                that.$router.replace({
                  path: "/",
                  query: {
                    cityName: that.cityName,
                    landmark: that.landmark
                  }
                });
              } else {
                that.cityName = "北京";
                that.removeStore("abroad");
                that.removeStore("cityName");
                Toast("无法获取您的定位");
                that.landmark = "";
                that.getHotCity();
                that.$router.replace({
                  path: "/",
                  query: {
                    cityName: "北京"
                  }
                });
              }
            });
        })
        .catch(err => {
          that.position = "我的位置";
          that.cityName = "北京";
          that.removeStore("abroad");
          that.removeStore("cityName");
          Toast("无法获取您的定位");
          that.landmark = "";
          that.$router.replace({
            path: "/",
            query: {
              cityName: "北京"
            }
          });
        });
    },
    checkDate() {
      this.$router.push({
        path: "/calendarPage",
        query: { calendarType: 3 }
      });
    },
    chooseCity() {
      const that = this;
      this.$router.push({
        path: "/city",
        cityName: that.cityName
      });
    },
    choosePlace() {
      const that = this;
      this.$router.push({
        path: "/searchCity",
        query: {
          cityId: that.getStore("abroad")
            ? JSON.parse(that.getStore("abroad")).cityId
            : "12",
          city: that.cityName,
          cityAndLandmark: that.landmark,
          checkInDay: that.getStore("setData")
            ? JSON.parse(that.getStore("setData")).checkInDay
            : "",
          checkOutDay: that.getStore("setData")
            ? JSON.parse(that.getStore("setData")).checkOutDay
            : "",
          timeZone: that.getStore("abroad")
            ? JSON.parse(that.getStore("abroad")).timeZone
            : "+08:00",
          origin: "index"
        }
      });
    },
    clearLand() {
      const that = this;
      this.landmark = "";
      this.$router.replace({
        path: "/",
        query: {
          cityId: that.getStore("abroad")
            ? JSON.parse(that.getStore("abroad")).cityId
            : "12",
          city: that.cityName
        }
      });
    },
    roomDetail(id) {
      const that = this;
      this.$router.push({
        name: "detail",
        query: {
          luId: id,
          checkInDay: that.getStore("setData")
            ? JSON.parse(that.getStore("setData")).checkInDay
            : "",
          checkOutDay: that.getStore("setData")
            ? JSON.parse(that.getStore("setData")).checkOutDay
            : ""
        }
      });
    },
    getVipInfoObj() {
      const that = this;
      // 获取会员信息；
      that.$get(getVipInfo, {}).then(res => {
        this.setStore("vipInfo", res.content);
        const vipInfo = this.getStore("vipInfo")
          ? JSON.parse(this.getStore("vipInfo"))
          : {};
        // gio 获取会员信息
      });
    },
    initDate() {
      // 今天的时间
      const day = new Date();
      const date = day.getDate() >= 10 ? day.getDate() : "0" + day.getDate();
      let todayMonth = day.getMonth() + 1;
      todayMonth = todayMonth >= 10 ? todayMonth : "0" + Number(todayMonth);
      const today = todayMonth + "." + date;
      this.checkIn = today;
      // 明天的时间
      const day2 = day.setTime(day.getTime() + 24 * 60 * 60 * 1000);
      const date2 = day.getDate() >= 10 ? day.getDate() : "0" + day.getDate();
      let month = day.getMonth() + 1;
      month = month >= 10 ? month : "0" + Number(month);
      const tommorrow = month + "." + date2;
      this.weekSt = "今天";
      this.weekEt = "明天";
      this.checkOut = tommorrow;
      this.totalDay = 1;
      this.setStore("setData", {
        startDateFul: new Date().getFullYear() + today.split(".").join(""),
        endDateFul: day.getFullYear() + tommorrow.split(".").join(""),
        checkInDay: new Date().getFullYear() + "-" + today.split(".").join("-"),
        checkOutDay: day.getFullYear() + "-" + tommorrow.split(".").join("-"),
        keepDays: 1,
        totalDay: 1
      });
    },
    getWeekByDay(dayValue) {
      // dayValue=“2014.01.01”
      const day = new Date();
      const date = day.getDate() >= 10 ? day.getDate() : "0" + day.getDate();
      const today = day.getMonth() + 1 + "." + date;
      // 明天的时间
      const day2 = day.setTime(day.getTime() + 24 * 60 * 60 * 1000);
      const date2 = day.getDate() >= 10 ? day.getDate() : "0" + day.getDate();
      const tommorrow = day.getMonth() + 1 + "." + date2;
      // 判断日期选择是否为今天、明天
      if (dayValue.slice(5) == today) {
        return "今天";
      } else if (dayValue.slice(5) == tommorrow) {
        return "明天";
      } else {
        // 返回周几
        const days = new Date(Date.parse(dayValue.replace(/\./g, "/"))); // 将日期值格式化
        const week = new Array(
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六"
        ); // 创建星期数组
        return week[days.getDay()]; // 返一个星期中的某一天，其中0为星期日
      }
    },
    fix(num, length) {
      return ("" + num).length < length
        ? (new Array(length + 1).join("0") + num).slice(-length)
        : "" + num;
    },
    initCity() {
      const that = this;
      const defaultCity = {
        cityId: 12,
        cityName: "北京",
        timeZone: "+08:00"
      };
      if (!that.getStore("abroad")) {
        that.setStore("hasAbordCity", 0);
        that.setStore("cityName", "北京");
        that.setStore("abroad", JSON.stringify(defaultCity));
      }
    },
    initData() {
      const that = this;
      if (!that.checkIn || !this.checkOut) {
        that.checkIn = "";
        this.checkOut = "";
        that.initDate();
      }
      if (that.getStore("setData")) {
        const localDate = JSON.parse(that.getStore("setData"));
        // 设定开始时间
        const startDateFul = localDate.checkInDay.split("-").join("");
        localDate.startDateFul = startDateFul;
        this.setStore("setData", localDate);
        // 周几
        this.weekSt = this.getWeekByDay(
          localDate.checkInDay.split("-").join(".")
        );
        this.weekEt = this.getWeekByDay(
          localDate.checkOutDay.split("-").join(".")
        );
        const date = new Date();
        // 比较大小
        const today =
          date.getFullYear() +
          that.fix(date.getMonth() + 1, 2) +
          that.fix(date.getDate(), 2);
        if (today > startDateFul) {
          // 开始时间 大于结束时间 清除日期信息 初始化 日期
          that.removeStore("setData");
          that.checkIn = "";
          that.checkOut = "";
          that.initDate();
        }
      }
    },
    getHotCity() {
      const that = this;
      const params = {
        cityId: that.getStore("abroad")
          ? JSON.parse(that.getStore("abroad")).cityId
          : "12",
        checkInDay: that.getStore("setData")
          ? JSON.parse(that.getStore("setData")).checkInDay
          : "",
        checkOutDay: that.getStore("setData")
          ? JSON.parse(that.getStore("setData")).checkOutDay
          : "",
        offset: 0,
        length: 10
      };
      params.client = "html5"
      params.role = "xzfk"
      this.$get(getResultList, params).then(res => {
        if (res.status == 200 && res.content && res.content.item) {
          that.hotLuList = res.content.item;
        }
      });
    },
    searchPrams() {
      const that = this;
      const cityInfo = this.getStore("abroad")
        ? JSON.parse(this.getStore("abroad"))
        : "";
      const lastCheckday = this.getStore("setData")
        ? JSON.parse(this.getStore("setData"))
        : "";
      const query = {};
      const urlQuery = that.$route.query;
      query.cityId = cityInfo.cityId ? cityInfo.cityId : "12";
      query.city = that.cityName;
      query.landmark = that.landmark;
      query.abroad = cityInfo.abroad;
      query.timeZone = encodeURIComponent(cityInfo.timeZone || "");
      // 地标信息
      if (that.landmark) {
        query.latitude = cityInfo.latitude || urlQuery.latitude;
        query.longitude = cityInfo.longitude || urlQuery.longitude;
        query.landmarkid = cityInfo.localId || cityInfo.locId || urlQuery.landmarkid;
        query.distId = cityInfo.districtId;
      }
      // 入住日期
      if (lastCheckday.checkInDay && lastCheckday.checkOutDay) {
        query.checkInDay = lastCheckday.checkInDay;
        query.checkOutDay = lastCheckday.checkOutDay;
      } else {
        query.checkInDay = "";
        query.checkOutDay = "";
      }
      return query;
    },
    searchList() {
      const params = this.searchPrams();
      // 搜索结果页
      this.$router.push({ name: "result", query: params });
    },
    toSearch(iconObj) {
      const that = this;
      const params = that.searchPrams();
      // 加入搜索标签
      // huXing: 户型，lodgeUnitTag: 标签，速定：19 近地铁：36；orderBy: 好评排序 zuihaoping
      if (iconObj.linkUrl == "oneRoom") {
        // 一室一厅
        params.huXing = 1;
        params.leaseType = "whole";
      } else if (iconObj.linkUrl == "quick") {
        // 速定
        params.lodgeUnitTag = 19;
      } else if (iconObj.linkUrl == "nearMetro") {
        // 近地铁
        params.lodgeUnitTag = 36;
      } else {
        // 好评排序
        params.orderBy = "zuihaoping";
      }
      // 搜索结果页
      this.$router.push({ name: "result", query: params });
    },
    getMore() {
      const that = this;
      // 获取更多热门民宿
      this.$router.push({
        path: "/result",
        query: {
          cityId: that.getStore("abroad")
            ? JSON.parse(that.getStore("abroad")).cityId
            : "12",
          city: that.cityName,
          checkInDay: that.getStore("setData")
            ? JSON.parse(that.getStore("setData")).checkInDay
            : "",
          checkOutDay: that.getStore("setData")
            ? JSON.parse(that.getStore("setData")).checkOutDay
            : "",
          timeZone: that.getStore("abroad")
            ? JSON.parse(that.getStore("abroad")).timeZone
            : "+08:00"
        }
      });
    },
    goUrl(url) {
      if (url) {
        window.location.href = url;
      }
    },
    bottomClick(item) {
      item.link && window.open(item.link);
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-record {
  width: 100%;
  background: #f5f5f5;
  padding: 12px 15px 4px 15px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  span {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #757575;
    height: 12px;
    margin-bottom: 8px;
  }
  span:first-of-type {
    margin-right: 35px;
  }
  span:nth-of-type(2) {
    margin-right: 20px;
  }
  span:nth-of-type(3),
  span:nth-of-type(5) {
    margin-right: 25px;
  }
}
.indexWrap {
  padding-bottom: 60px;
}
.indexWrap .hotBox .hotRoomBox .luInfo .luName{
  -webkit-line-clamp: 1;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue